import { Component, ComponentType } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { compose } from 'redux';
import { IApplicationState } from '@bridebook/web/lib/types';
import { getScreenType } from '@bridebook/web/lib/app/selectors';

const storeEnhancer = connect((state: IApplicationState) => ({
  isMobile: getScreenType(state).isMobile,
  isTablet: getScreenType(state).isTablet,
}));

interface ComponentProps {
  hover?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

interface IProps extends ConnectedProps<typeof storeEnhancer>, ComponentProps {}

interface IState {
  hover: boolean;
}

const hoverHoc = (WrappedComponent: React.ComponentType<IProps>) =>
  class hoverStateTrigger extends Component<IProps, IState> {
    state = {
      hover: false,
    };

    onMouseEnter = () => this.setState({ hover: true });

    onMouseLeave = () => this.setState({ hover: false });

    render() {
      const { isMobile, isTablet } = this.props;

      return isMobile || isTablet ? (
        <WrappedComponent {...this.props} />
      ) : (
        <WrappedComponent
          {...this.props}
          hover={this.state.hover}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
        />
      );
    }
  };

export default compose<ComponentType>(storeEnhancer, hoverHoc);
